import UserTokenCallback from '../schema/UserTokenCallback';

let userTokenCallback: UserTokenCallback | undefined;

export function setUserTokenCallback(callback?: UserTokenCallback) {
    userTokenCallback = callback;
}

export async function getUserToken(): Promise<string | undefined> {
    const token = userTokenCallback && (await userTokenCallback());
    if (token) {
        return token.split(' ')[1]; //Token is returned with 'Bearer' prefix. Drop the prefix and return only the JWT token.
    }

    return undefined;
}
